import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Launchpad from "../components/Launchpad";
import LaunchpadBanner from "../components/LaunchpadBanner";

const LaunchpadList = () => {
	return (
		<>
			<Header />
			<LaunchpadBanner />
			<Launchpad title="Launchpad List" pagination />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer />
		</>
	);
};

export default LaunchpadList;
